import { IOption } from 'types/textValue';

export const getYAxisValue = (
  currentValue: string,
  yAxisOptions: IOption[],
): string =>
  (yAxisOptions.find((option) => option.value === currentValue)
    ?.value as string) ?? (yAxisOptions[0].value as string);
